import Rating from "@material-ui/lab/Rating";
import React, { useEffect } from "react";

const StarRatingBlock = (props: any) => {
  const [value, setValue] = React.useState<number | null>(props.value);
  useEffect(() => {
    if (!isNaN(props.value)) {
      setValue(props.value);
    }

  }, [props]);

  return (
    <React.Fragment>
      <div tabIndex={0} aria-label="star rating">
        <Rating aria-label="star rating"
          value={value}
          onChange={(event: any, newValue: any) => {
            if (props.isEditable) {
              setValue(newValue);
              props.setStarRating(newValue);
            }
          }}
          readOnly={!props.isEditable}
        />
      </div>
    </React.Fragment>
  );
};

export default StarRatingBlock;
